import TYPES from './types';
import { put } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateClassificationSociety = params => dispatch => {
  const { id, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_CLASSIFICATION_SOCIETY.START, payload: { params } });
  dispatch(updateTableRow({ data: params, table }));

  return put(`/classification-societies/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_CLASSIFICATION_SOCIETY.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({
        type: TYPES.UPDATE_CLASSIFICATION_SOCIETY.ERROR,
        payload: { response: error, params }
      });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};
